import React, { useState, useEffect } from 'react';
import './ProductDropdown.css';
const ProductDropdown = ({ onAddProduct }) => {
  const [products, setProducts] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedVariants, setSelectedVariants] = useState([]);
  const [quantityMap, setQuantityMap] = useState({});
  const [price, setPrice] = useState(0);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await fetch('https://app.mirzawaleed.com/getProducts.php');
        const data = await response.json();
        setProducts(data);
      } catch (error) {
        console.error('Error fetching products:', error);
      }
    };

    fetchProducts();
  }, []);

  const handleProductChange = (event) => {
    const productId = event.target.value;
    const product = products.find((p) => p.id === productId);
    setSelectedProduct(product);
    setSelectedVariants([]);
    setQuantityMap({});
    setPrice(product ? product.price : 0);
  };

  const handleVariantChange = (variantId, checked) => {
    if (checked) {
      setSelectedVariants([...selectedVariants, variantId]);
    } else {
      setSelectedVariants(selectedVariants.filter((id) => id !== variantId));
    }
  };

  const handleQuantityChange = (variantId, quantity) => {
    setQuantityMap((prev) => ({
      ...prev,
      [variantId]: quantity,
    }));
  };

  const handleProductQuantityChange = (quantity) => {
    setQuantityMap((prev) => ({
      ...prev,
      product: quantity,
    }));
  };

  const handlePriceChange = (event) => {
    setPrice(parseFloat(event.target.value));
  };

  const handleAddProduct = () => {
    if (!selectedProduct) return;

    // Validate quantities
    const quantities = selectedProduct.variants && selectedProduct.variants.length > 0 
      ? selectedVariants.map((id) => quantityMap[id] || '1') 
      : [quantityMap.product || '1'];

    // Ensure quantities are numbers and not empty
    const invalidQuantities = quantities.some((qty) => isNaN(parseFloat(qty)) || parseFloat(qty) <= 0);
    
    if (invalidQuantities) {
      alert("Please enter valid quantities greater than 0.");
      return;
    }

    if (selectedProduct.variants && selectedProduct.variants.length > 0) {
      const productsWithVariants = selectedProduct.variants
        .filter(variant => selectedVariants.includes(variant.id))
        .map(variant => ({
          id: selectedProduct.id,
          variant_id: variant.id,
          name: `${selectedProduct.name} - ${variant.name || 'Unnamed Variant'}`,
          variant: variant.name || 'Unnamed Variant',
          quantity: parseFloat(quantityMap[variant.id]) || 1,
          price: selectedProduct.price,
          rate: price
        }));
      
      onAddProduct(productsWithVariants);
      console.log(selectedProduct.id);
      console.log(productsWithVariants);

    } else {
      const productWithoutVariants = [{
        id: selectedProduct.id,
        name: selectedProduct.name,
        price,
        quantity: parseFloat(quantityMap.product) || 1,
        rate: price
      }];
      

      console.log(selectedProduct.id);

      onAddProduct(productWithoutVariants);
    }
  };

  return (
    <div className='product-dropdown'>
      <div>
        <label>Select Product:</label>
        <select value={selectedProduct?.id || ''} onChange={handleProductChange}>
          <option value="">Select Product</option>
          {products.map((product) => (
            <option key={product.id} value={product.id}>
              {product.name}
            </option>
          ))}
        </select>
      </div>

      {selectedProduct && (
        <div>
          <h4>{selectedProduct.name}</h4>
          {selectedProduct.variants && selectedProduct.variants.length > 0 ? (
            <>
              <h5>Variants</h5>
              {selectedProduct.variants.map((variant) => (
                <div key={variant.id} className='variant-row'>
                  <input
                    type="checkbox"
                    value={variant.id}
                    onChange={(e) => handleVariantChange(variant.id, e.target.checked)}
                  />
                  <label style={{ marginLeft: '10px' }}>
                    {variant.name || 'Unnamed Variant'}
                  </label>
                  <input
                    type="number"
                    placeholder="Quantity"
                    value={quantityMap[variant.id] || ''}
                    onChange={(e) => handleQuantityChange(variant.id, e.target.value)}
                  />
                </div>
              ))}
            </>
          ) : (
            <div style={{ marginTop: '20px' }}>
              <label>Quantity:</label>
              <input
                type="number"
                placeholder="Quantity"
                value={quantityMap.product || ''}
                onChange={(e) => handleProductQuantityChange(e.target.value)}
                style={{ marginLeft: '10px' }}
              />
            </div>
          )}

          <div style={{ marginTop: '20px' }}>
            <label>Price:</label>
            <input
              type="number"
              value={price}
              onChange={handlePriceChange}
              className='price-varaint'
            />
          </div>

          <button onClick={handleAddProduct} style={{ marginTop: '20px' }}>
            Add Product
          </button>
        </div>
      )}
    </div>
  );
};

export default ProductDropdown;
